import * as React from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  Grid,
  Divider,
} from '@mui/material';
import CloseIcon from '@material-ui/icons/Close';
import { DatePicker, Select, Chip } from '..';
import IconButton from '@material-ui/core/IconButton';
import PropTypes from 'prop-types';
import { ArrowDownward, ArrowUpward } from '@mui/icons-material';
import { FILTER_CONSTANTS, SORT_TYPES } from '../../Constants';
import './styles.css';

const titleStyle4 = {
  fontFamily: 'Mukta',
  fontSize: '15px',
  lineHeight: '20px',
  fontWeight: '700',
  color: '#054E8B',
};
const titleStyle = {
  fontSize: '19px',
  lineHeight: '25px',
  fontWeight: '700',
  color: '#054E8B',
  fontFamily: 'Mukta',
};

const FilterPopup = (props) => {
  const handleClose = () => {
    props.setFilterPopup(false);
  };

  return (
    <Dialog
      sx={{
        '& .MuiDialogContent-root ': {
          padding: '0px 0px',
        },
      }}
      PaperProps={{
        style: {
          margin: '2px',
        },
      }}
      margin={0}
      open={props.filterPopup}
      onClose={handleClose}
    >
      <DialogContent>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          backgroundColor="white"
        >
          <Box
            className="filter-pop-up"
            sx={{
              boxShadow: '3',
              padding: '20px',
              paddingRight: '16px',
              width: '100%',
              backgroundColor: '#FFFFFF',
              display: 'inline',
            }}
          >
            <Box
              sx={{
                display: 'inline',
                width: '100%',
              }}
            >
              <IconButton
                onClick={handleClose}
                style={{
                  padding: '0px',
                  color: '#8493AE',
                  float: 'right',
                  marginTop: '-10px',
                  marginRight: '-10px',
                }}
              >
                <CloseIcon className="filter-close-icon" />
              </IconButton>
            </Box>
            <Box
              sx={{
                display: 'inline',
                flexDirection: 'column',
                maxWidth: '350px',
                width: '100%',
              }}
            >
              <Box
                sx={{
                  marginBottom: '20px',
                }}
              >
                <Box style={titleStyle}>Filter By</Box>
              </Box>
              <Box
                sx={{
                  marginBottom: '20px',
                }}
              >
                <Box style={titleStyle4} sx={{ marginBottom: '8.5px' }}>
                  Duty Status
                </Box>
                <Box
                  sx={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'row',
                    flexWrap: 'wrap',
                  }}
                >
                  <Select
                    multiple
                    variant="standard"
                    options={FILTER_CONSTANTS}
                    value={props.queryParams.order_type}
                    onChange={(e) => {
                      props.setQueryParams((prev) => {
                        return {
                          ...prev,
                          order_type: e.target.value,
                        };
                      });
                    }}
                    placeHolder="None"
                    renderValue={(selected) => {
                      if (selected.length === 0) {
                        return <em>None</em>;
                      } else {
                        return (
                          <Box
                            sx={{
                              display: 'flex',
                              flexWrap: 'wrap',
                              gap: 0.5,
                              mb: '4px',
                            }}
                          >
                            {selected.map((value, index) => {
                              return (
                                <Chip
                                  key={index}
                                  label={value}
                                  handleDelete={() => {
                                    props.setQueryParams((prev) => {
                                      return {
                                        ...prev,
                                        order_type: prev.order_type.filter(
                                          (element) => element != value
                                        ),
                                      };
                                    });
                                  }}
                                />
                              );
                            })}
                          </Box>
                        );
                      }
                    }}
                  />
                </Box>
              </Box>
              <Box
                sx={{
                  marginBottom: '20px',
                }}
              >
                <Box
                  style={titleStyle4}
                  sx={{
                    marginBottom: '8.5px',
                    display: 'flex',
                    gap: '4px',
                    alignItems: 'center',
                  }}
                >
                  Sort By
                  <Box sx={{ pl: 2 }}>
                    <Select
                      options={SORT_TYPES}
                      value={props.queryParams.attributeToSort}
                      onChange={(e) => {
                        props.setQueryParams((prev) => {
                          return {
                            ...prev,
                            attributeToSort: e.target.value,
                          };
                        });
                      }}
                      placeHolder="None"
                    />
                  </Box>
                  <Box>
                    {props.queryParams.attributeToSort && (
                      <IconButton
                        size="small"
                        onClick={() => {
                          props.setQueryParams((prev) => {
                            return {
                              ...prev,
                              sortBy: prev.sortBy === 'asc' ? 'desc' : 'asc',
                            };
                          });
                        }}
                      >
                        {props.queryParams.sortBy === 'asc' ? (
                          <ArrowDownward
                            sx={{
                              color: '#054E8B',
                              fontSize: '18px',
                            }}
                          />
                        ) : (
                          <ArrowUpward
                            sx={{
                              color: '#054E8B',
                              fontSize: '18px',
                            }}
                          />
                        )}
                      </IconButton>
                    )}
                  </Box>
                </Box>
              </Box>
              <Divider
                sx={{
                  borderTop: 1,
                  borderBottomWidth: '0px',
                  borderColor: '#CAD3E5',
                  width: '100%',
                  marginBottom: '20px',
                }}
              />
              <Box sx={{ marginBottom: '21px' }}>
                <DatePicker
                  queryParams={props.queryParams}
                  setQueryParams={props.setQueryParams}
                />
              </Box>
              <Divider
                sx={{
                  borderTop: 1,
                  borderBottomWidth: '0px',
                  borderColor: '#CAD3E5',
                  width: '100%',
                  marginBottom: '20px',
                }}
              />
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  zIndex: 8,
                  alignSelf: 'stretch',
                  width: '100%',
                }}
              >
                <Button
                  variant="text"
                  className="clear-filter-btn"
                  sx={{
                    textTransform: 'none',
                    '&.MuiButtonBase-root': {
                      maxWidth: '145px',
                      fontSize: '15px',
                      gap: '8px',
                      lineHeight: '19px',
                      fontFamily: 'Mulish',
                      color: '#111111',
                    },
                  }}
                  onClick={() => {
                    props.setQueryParams((prev) => {
                      return {
                        ...prev,
                        order_type: [],
                        attributeToSort: '',
                        sortBy: '',
                        sortByDate: false,
                        startDate: new Date(),
                        endDate: new Date(),
                      };
                    });
                    props.setApply(!props.apply);
                    props.setQueryParams({
                      order_type: [],
                      attributeToSort: '',
                      status: 'assigned',
                      sortBy: '',
                      sortByDate: false,
                      startDate: new Date(),
                      endDate: new Date(),
                    });
                    handleClose();
                  }}
                >
                  Clear All Filters
                </Button>
                <Button
                  onClick={handleClose}
                  sx={{
                    textTransform: 'none',
                    width: '100%',
                    '&.MuiButtonBase-root': {
                      maxWidth: '87px',
                      fontSize: '15px',
                      lineHeight: '19px',
                      gap: '8px',
                      padding: '0px',
                      fontFamily: 'Mulish',
                      color: '#EA4C59',
                    },
                  }}
                >
                  Cancel
                </Button>
                <Button
                  variant="text"
                  sx={{
                    textTransform: 'none',
                    width: '100%',
                    '&.MuiButtonBase-root': {
                      maxWidth: '83px',
                      borderRadius: '8px',
                      gap: '8px',
                      backgroundColor: '#054E8B',
                      color: '#FFFFFF',
                    },
                    '&:disabled': {
                      backgroundColor: 'e0e0e0',
                    },
                  }}
                  onClick={() => {
                    props.setApply(!props.apply);
                    handleClose();
                  }}
                  disabled={
                    props.queryParams.sortByDate &&
                    props.queryParams.endDate === null
                      ? true
                      : false
                  }
                >
                  Apply
                </Button>
              </Box>
            </Box>
          </Box>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};
FilterPopup.propTypes = {
  queryParams: PropTypes.object.isRequired,
  setApply: PropTypes.func.isRequired,
  apply: PropTypes.bool.isRequired,
  setQueryParams: PropTypes.func.isRequired,
  filterPopup: PropTypes.bool.isRequired,
  setFilterPopup: PropTypes.func.isRequired,
};

export default React.memo(FilterPopup);
